import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'spanishDate',
  standalone: true
})
export class SpanishDatePipe implements PipeTransform {
  transform(value: any, format: string = 'EEEE dd \'de\' MMMM YYYY'): string {
    const datePipe = new DatePipe('es-ES');
    return datePipe.transform(value, format) || '';
  }
}